import React, { useState, useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';

import useStyles from "./styles";
import { withSnackbar } from "./../../../../components/Message/Alert";
import { formateMdnNumber, formatDateTime, } from './../../../../components/Common/Extensions';
import { PostDataAPI } from './../../../../Services/APIService';
import DialogLoader from './../../../../components/Loader/DialogLoader';
import { ActionDialog } from "./../../../../components/ActionDialog/ActionDialog";
import Tooltip from '@material-ui/core/Tooltip';
import { DraggableComponent } from './../../../../components/UiElements/UiElements';
import NoRecord from './../../../../components/NoRecord/NoRecord';


function ViewNotes({ dialogOpenClose, handleClose, handleSuccessClose, addressBookId, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [notesData, setNotesData] = useState([]);


    //action dialog 
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }

    const LoadAddressBookNotes = () => {
        var params = { AddressBookId: addressBookId }
        PostDataAPI("figgaddressbook/getAddressBookNotes", params, true).then((result) => {
            if (result.success && result.data != null) {
                setNotesData(result.data);
            }
        })
    }

    useEffect(() => {
        LoadAddressBookNotes()
    }, []);

    return (
        <>
            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableBackdropClick
                disableEscapeKeyDown
                open={dialogOpenClose}
                PaperComponent={DraggableComponent}
                maxWidth="lg"
                {...props} >
                <div className={classes.dialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>View Notes</Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                            {/* <span className={classes.crossButton} onClick={handleClose}><img src={CloseIcon} alt="close" /></span> */}
                        </div>
                        <div className={classes.content}>
                            <Scrollbars autoHeight autoHeightMin={150} autoHeightMax={600}>
                                {isLoading ? <DialogLoader></DialogLoader> : ''}
                                <Grid container direction="column">

                                    {notesData.length > 0 ?
                                        notesData.map((item, i) => (
                                            <div className={classes.recentActivityList}>
                                                <Grid container alignItems="center">
                                                    <Grid item row lg={1} className="textRight"> <span className={classes.smallRadius}></span> </Grid>
                                                    <Grid item row className={classes.borderContent}>
                                                        <p dangerouslySetInnerHTML={{
                                                            __html: item.notes,
                                                        }}>
                                                        </p>

                                                        <span>{formatDateTime(item.createDate)}</span>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                        )) : <NoRecord></NoRecord>
                                    }

                                </Grid>
                            </Scrollbars>
                        </div>

                    </div>
                </div>
            </Dialog >

            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />
        </>
    )
}
export default withSnackbar(ViewNotes);